// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","brand":"Footer_brand__QKAvM","ax":"Footer_ax__JvJrj","links":"Footer_links__wMgLO"};